import SelectField from "../../../../../Form/SelectField";
import TextField from "../../../../../Form/TextField";
import SaveButton from "../../../../../shared/Buttons/SaveButton";
import NewModal from "../../../../../shared/Modals/NewModal";
import InvitationForm from "@serie3/common/Modules/Invitations/Forms/InvitationForm";
import { useFormik } from "formik";
import { Row, Col } from "react-bootstrap";

const InviteModal = ({ show, setShow, dataList, setDataList, groupId }) => {
  const invitationForm = InvitationForm.createInvitationForm(
    dataList,
    setDataList,
    groupId
  );

  const formik = useFormik(invitationForm);

  const Save = () => {
    return (
      <>
        <SaveButton
          submitFunction={(e) => {
            formik.handleSubmit(e);
            e.preventDefault();
          }}
        />
      </>
    );
  };

  return (
    <NewModal show={show} setShow={setShow} ExtraButton={Save}>
      <Row>
        <Col>
          <TextField
            label="Email"
            formik={formik}
            valueName={"user_mail"}
            style={{ marginBottom: "10px" }}
          />
          <SelectField
            label="Role"
            formik={formik}
            valueName={"caps"}
            style={{ paddingBottom: "10px" }}
          >
            <option value="">-- choose a role --</option>
            <option value="GROUP_ROLE_MEMBER">Member</option>
            <option value="GROUP_ROLE_ADMIN">Admin</option>
          </SelectField>
        </Col>
      </Row>
    </NewModal>
  );
};

export default InviteModal;
